import moment from "moment";
import { CustomIcon } from "datastake-daf/dist/components";
import { renderData } from "../../../../DataStore/DataStoreView/config";
import { camelCaseToTitle } from "../../../../../helpers/StringHelper";

export const selectFiltersConfig = {};

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};

export const columnsConfig = ({
  mod,
  channelId,
  subjectId,
  t = (s) => s,
  form = {},
  goTo = () => { },
}) => [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return item.datastakeId || item.id;
      },
    },
    {
      title: t('Data Point'),
      dataIndex: 'dataId',
      key: 'dataId',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return camelCaseToTitle(v);
      },
    },
    {
      title: t('Data'),
      dataIndex: 'data',
      key: 'data',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return renderData(v, form, item.dataId);
      },
    },
    {
      title: t('Origin'),
      dataIndex: 'origin',
      key: 'origin',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return v || '--';
      },
    },
    {
      title: t('Version'),
      dataIndex: 'version',
      key: 'version',
      ellipsis: true,
    },
    {
      title: t('Date'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (v, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        return moment(v).format('DD MMM YYYY');
      },
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: 60,
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        return (
          <div
            className="cursor-pointer"
            onClick={() => goTo(`/app/${mod}/information-channels/${channelId}/${subjectId}/${val.datastakeId || val.id}`)}
          >
            <CustomIcon color="#6C737F" name="View" width={12} height={12} />
          </div>
        );
      },
      ellipsis: true,
    },
  ]
